import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLeadReportAdmin } from "../../services/adminreport.services";

export const fetchLeadReportAdmin = createAsyncThunk(
  "leadReportAdmin/fetch",
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      const data = await getLeadReportAdmin(startDate, endDate);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const adminleadReportSlice = createSlice({
  name: "leadReportAdmin",
  initialState: {
    data: {}, // Holds aggregated data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Holds any error message
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeadReportAdmin.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLeadReportAdmin.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload; // Store lead report data
      })
      .addCase(fetchLeadReportAdmin.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload; // Store error message if fetch fails
      });
  },
});

export default adminleadReportSlice.reducer;
